import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=166b593c&scoped=true&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=166b593c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166b593c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Development/2020/invoicing/crater-20201222/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('166b593c')) {
      api.createRecord('166b593c', component.options)
    } else {
      api.reload('166b593c', component.options)
    }
    module.hot.accept("./GlobalSearch.vue?vue&type=template&id=166b593c&scoped=true&", function () {
      api.rerender('166b593c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/GlobalSearch.vue"
export default component.exports